(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5569],{

/***/ 8093:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/technology-consulting",
      function () {
        return __webpack_require__(8062);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MethodologyAnchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var steps = [
    {
        step: "01",
        title: "Discovery sprint",
        desc: "2 weeks, fixed price. We scope the problem, audit your data, and produce a written roadmap, cost estimate, and risk register. You decide whether to proceed — no commitment beyond the sprint."
    },
    {
        step: "02",
        title: "Build",
        desc: "Fixed-scope first phase or time-and-materials with a cap. Production-grade code, not a prototype. Delivered into your cloud environment with tests, monitoring, and handoff documentation."
    },
    {
        step: "03",
        title: "Operate",
        desc: "4–8 week warranty period post-handoff. Bugs and regressions fixed at zero cost. Ongoing ops available — we don't disappear after delivery."
    }, 
];
function MethodologyAnchor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-5xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-2",
                    children: "How an engagement works"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-gray-500 mb-10 text-base",
                    children: "No open-ended retainers. Every engagement starts with a bounded, fixed-price discovery."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-8",
                    children: steps.map(function(s) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-3xl font-bold text-[#f1aa4e]",
                                    children: s.step
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-600 text-sm leading-relaxed",
                                    children: s.desc
                                })
                            ]
                        }, s.step);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/itmtb-how-we-work",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "text-blue-600 font-semibold text-sm hover:underline",
                            children: "Full methodology and engagement shapes →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 8062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3230);
/* harmony import */ var _components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2100);
/* harmony import */ var _components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(710);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2616);
/* harmony import */ var _components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5733);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4837);







var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});






var ContactUsHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6245).then(__webpack_require__.bind(__webpack_require__, 6245));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6245)
            ];
        }
    },
    ssr: false
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
technologyConsulting.title = "Technology Consulting — Technical Due Diligence & Stack Migrations | ITMTB";
technologyConsulting.desc = "ITMTB provides technical due diligence, stack migrations, and performance consulting for enterprise technology decisions — the team you bring in before replacing your stack.";
technologyConsulting.header_img = "https://www.itmtb.com/services/capability/tech consulting.webp";
technologyConsulting.keywords = "technology consulting India enterprise, technical due diligence India, stack migration consulting India, CTO advisory India, pre-investment tech audit India, technology modernisation India";
var faqItems = [
    {
        q: "What is technical due diligence and when do I need it?",
        a: "Technical due diligence is an independent assessment of a software system or technology stack, produced for a decision-maker who needs to understand what they're inheriting or investing in. The most common trigger points: pre-acquisition (what is the technical liability of the company we're buying?); pre-investment (is this startup's technology actually built, or is it held together with duct tape?); pre-rebuild (does this system actually need to be replaced, or can it be extended?); and pre-AI deployment (is this stack ready to integrate with AI agents, or does it need modernisation first?). The output is a written assessment covering architecture, security posture, scalability limits, technical debt inventory, dependency risks, and a prioritised list of findings with estimated remediation effort. ITMTB has conducted technical due diligence for fintech platforms processing millions of transactions, startup technology stacks ahead of funding rounds, and legacy enterprise systems being evaluated for AI-readiness."
    },
    {
        q: "What does a technology stack migration actually involve?",
        a: "A stack migration is a change to the underlying technology that runs a system — examples: Python 2 to Python 3, .NET Framework to .NET 8, Java EE to Spring Boot, monolith to microservices, on-premises to cloud, one cloud provider to another. The process has consistent steps regardless of the specific migration: (1) inventory — map all dependencies, interfaces, and integration points of the current system; (2) risk assessment — identify which components are most likely to behave differently after migration and what the failure modes are; (3) migration runbook — define the exact sequence of changes, the testing approach at each step, and the rollback procedure if a step fails; (4) execution — migrate progressively rather than as a big-bang cutover; (5) validation — test the migrated system against the original behaviour baseline. The biggest migration risk is undocumented behaviour: things the system does that nobody wrote down. We find those during the inventory phase before migration starts."
    },
    {
        q: "What is performance consulting and when is it worth doing?",
        a: "Performance consulting is an investigation into why a software system is slower, more expensive to run, or less reliable than it should be — and a set of specific, prioritised recommendations for fixing it. It's worth doing when: application response times are degrading as usage grows and the cause isn't obvious; cloud costs are increasing faster than load; a system that worked fine at small scale is becoming unreliable at production load; or you're about to add AI inference to a system and need to understand whether the current infrastructure can handle the additional load. Our performance consulting engagements start with instrumentation — adding the observability needed to diagnose the problem rather than guessing. Common findings: N+1 query problems that only appear under concurrent load, cache invalidation logic that's too aggressive, database indices that cover development data volumes but not production, and synchronous API calls that should be async."
    },
    {
        q: "How do you approach the decision to rebuild vs. extend a legacy system?",
        a: "Most of the time, extending is the right answer — and most organisations that rebuild from scratch find themselves 18 months later with a new system that has different problems but is no faster or cheaper. Rebuilding is genuinely warranted when: the existing system uses technology that is no longer maintained (Python 2, .NET Framework with no upgrade path, a vendor whose product is sunset); the architecture makes the system fundamentally unable to meet new requirements (synchronous-only when you need real-time, single-region when you need multi-region); or the cost of adding any new feature is so high due to technical debt that incremental extension is more expensive than rewrite over a 3-year horizon. In all other cases, a strangler-fig extension approach — wrapping the legacy system with a new interface and migrating functionality progressively — delivers the modernisation benefits without the timeline and risk of a full rebuild. We assess which path is appropriate during the discovery sprint, with a 3-year TCO comparison of both options."
    },
    {
        q: "Do you provide CTO-level technology advisory on an ongoing basis?",
        a: "Yes — for organisations without a full-time CTO or where the CTO needs a specialist partner for a specific domain (AI deployment, cloud architecture, security), we provide fractional technology advisory. This covers: attending architecture review sessions and providing independent assessment of proposals; reviewing vendor RFPs and evaluating responses; advising on build vs. buy decisions with a documented recommendation; advising on hiring — technical interview panels and role definition for engineering hires; and providing a second opinion before major technology investment decisions. The engagement is structured as a fixed monthly retainer with a defined scope of advisory hours and access to ITMTB's delivery team for specific investigations. Most fractional CTO engagements run 3–6 months during a period of significant technology decision-making."
    },
    {
        q: "How does ITMTB price an engagement?",
        a: "Pricing follows the engagement model. Discovery sprints are fixed-price for a fixed timebox. Build engagements are scoped after discovery — fixed-scope, time-and-materials, or outcome-linked. Managed services are billed monthly with defined SLAs. Total cost depends on scope, integration complexity, QA depth, and post-launch support — we publish a transparent breakdown for buyers evaluating their options.",
        link: "/blog/custom-software-development-cost-india",
        linkLabel: "Read the cost guide"
    },
    {
        q: "What does an engagement with ITMTB look like?",
        a: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically 2 weeks. You leave with a written roadmap, risk register, cost estimate, and timeline before committing to a build. We then offer four engagement models: fixed-scope builds, time-and-materials, outcome-linked retainers, and managed services post-launch. If discovery doesn't justify proceeding, you can stop there — no obligation.",
        link: "/itmtb-how-we-work",
        linkLabel: "See how we work"
    }, 
];
technologyConsulting.faq = faqItems;
function technologyConsulting() {
    var insights = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
    });
    var filteredInsights = insights.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Technology Consulting");
    });
    var filteredCaseStudies = caseStudies.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Technology Consulting");
    });
    if (filteredInsights.length === 1) {
        insights = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(filteredInsights).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(insights.filter(function(item) {
            return !filteredInsights.includes(item);
        }), 1)));
    } else if (filteredInsights.length >= 2) {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(filteredInsights, 2);
    } else {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(insights, 2);
    }
    if (filteredCaseStudies.length === 1) {
        caseStudies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(filteredCaseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(caseStudies.filter(function(item) {
            return !filteredCaseStudies.includes(item);
        }), 1)));
    } else if (filteredCaseStudies.length >= 2) {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(filteredCaseStudies, 2);
    } else {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(caseStudies, 2);
    }
    var subServices = [
        {
            img: null,
            key: "Technical Due Diligence",
            title: "The independent assessment you commission before making a major technology decision.",
            text: "Pre-acquisition, pre-investment, pre-rebuild, or pre-AI deployment: we produce a written technical assessment covering architecture, security posture, scalability limits, technical debt inventory, and a prioritised findings list with estimated remediation effort.\n\nUsed by investors evaluating startup technology before funding rounds, enterprise buyers assessing the technical liability of an acquisition, and product leaders deciding whether to rebuild or extend a legacy system."
        },
        {
            img: null,
            key: "Technical Migrations",
            title: "Stack migrations executed from a tested runbook — with a defined rollback path at every step.",
            text: "Migration paths we've executed: Python 2 to 3, .NET Framework to .NET 8, Java EE to Spring Boot, monolith to microservices, on-premises to cloud, legacy hosting to AWS/Azure. Every migration starts with a dependency inventory and risk assessment to find the undocumented behaviour that causes migration failures — before the migration starts.\n\nWe produce the migration runbook as a deliverable, so your team can execute, validate, and roll back with full visibility at each step."
        },
        {
            img: null,
            key: "Performance Consulting",
            title: "Diagnose why your system is slower or more expensive than it should be — then fix the specific problems.",
            text: "Performance consulting starts with instrumentation: adding the observability needed to diagnose the actual bottleneck rather than guessing. Common findings include N+1 query problems that only appear under concurrent load, caches that are invalidated too aggressively, database indices that cover development data volumes but not production, and synchronous calls that should be async.\n\nFor cloud-hosted systems, we also review cost efficiency — slow queries that run frequently are expensive, and the performance and cost fixes are often the same change."
        },
        {
            img: null,
            key: "Fractional CTO and Technology Advisory",
            title: "Specialist technology leadership for organisations making major technology decisions without a full-time CTO.",
            text: "We provide fractional CTO advisory for organisations at a technology inflection point: pre-AI deployment, during a major cloud migration, ahead of a significant engineering hire, or when evaluating a major vendor or platform decision.\n\nThe engagement covers architecture review sessions, vendor RFP evaluation, build vs. buy analysis, and technical interview panels for senior engineering hires — structured as a monthly retainer with defined advisory scope. Most engagements run 3–6 months."
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "ProfessionalService",
                            name: "Technology Consulting — Technical Due Diligence & Stack Migrations India",
                            url: "https://www.itmtb.com/services/technology-consulting",
                            image: "https://www.itmtb.com/services/capability/tech consulting.webp",
                            description: "ITMTB provides technical due diligence, stack migrations, and performance consulting for enterprise technology decisions — the team you bring in before replacing your stack.",
                            provider: {
                                "@type": "Organization",
                                name: "ITMTB Technologies",
                                url: "https://www.itmtb.com",
                                logo: "https://www.itmtb.com/logo.webp"
                            },
                            areaServed: [
                                {
                                    "@type": "Place",
                                    name: "India"
                                }
                            ],
                            serviceType: [
                                "Technology Consulting India",
                                "Technical Due Diligence India",
                                "Stack Migration Consulting",
                                "CTO Advisory India",
                                "Pre-Investment Tech Audit India",
                                "Technology Modernisation India",
                                "Performance Consulting",
                                "Engineering Due Diligence", 
                            ],
                            sameAs: [
                                "https://www.linkedin.com/company/itmtb-technologies/",
                                "https://x.com/ITMTBTech",
                                "https://www.instagram.com/itmtbtech/", 
                            ]
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                heading: "Technology Consulting",
                paragraph: "Technical due diligence and stack migrations — the team you bring in before you replace your stack.\n\nMost rebuild decisions are made without a rigorous assessment of the alternative: extend. Most stack migrations fail not in execution but in the inventory phase — undocumented behaviour that nobody mapped before migration started. Most technology decisions made under deadline pressure get revisited at significant cost 18 months later.\n\nWe've conducted technical due diligence for fintechs processing millions of transactions daily, startup technology stacks ahead of funding rounds, and legacy enterprise systems being evaluated for AI-readiness. We give you the independent view before the commitment.",
                bgPath: "/services/capability/tech consulting.webp",
                primaryCta: {
                    label: "Talk to us →",
                    href: "/contact-us"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                referTag: "Technology Consulting",
                maxItems: 3,
                heading: "Selected work in technology consulting"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_10__/* .CustomerSection */ .a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed max-w-3xl mb-10",
                            children: [
                                "A rebuild-versus-extend decision turns on numbers that are easy to get wrong. Before committing, it helps to understand",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/blog/custom-software-development-cost-india",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                        children: "what custom software actually costs to own in India"
                                    })
                                }),
                                " ",
                                "— pricing models, support SLAs, and the lifecycle spend that follows delivery."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-7",
                            children: "Related capabilities"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-5",
                            children: [
                                {
                                    href: "/services/forward-deployed-engineering",
                                    label: "Forward Deployed Engineering",
                                    desc: "When a decision needs to become a running system: a senior pod embedded with your team to take an AI use case from discovery to secure production. Also home to our Fractional Technology Leadership engagements."
                                },
                                {
                                    href: "/services/tech-stack-audit",
                                    label: "Tech Stack Audit",
                                    desc: "The operational health-check, not the boardroom decision: a productised, fixed-scope review of a live software, cloud, and security stack when you need to know what to fix, modernise, or rebuild."
                                },
                                {
                                    href: "/services/strategy",
                                    label: "Strategy",
                                    desc: "Business-aligned technology strategy and roadmaps for organisations planning their next phase of growth."
                                },
                                {
                                    href: "/services/managed-services",
                                    label: "Managed Services",
                                    desc: "Ongoing operations, monitoring, and production support for the systems you run once the decision is made."
                                },
                                {
                                    href: "/services/data-center-project-readiness-governance",
                                    label: "Data Centre Readiness",
                                    desc: "Data centre readiness and delivery governance: independent risk, vendor, approval, and decision support before and during a captive, DR, or hybrid data centre setup."
                                }, 
                            ].map(function(link) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: link.href,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "block bg-white border border-gray-200 rounded-xl p-6 hover:border-indigo-400 hover:shadow-sm transition-all group",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors mb-2",
                                                children: link.label
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 leading-relaxed",
                                                children: link.desc
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "mt-4 inline-block text-sm font-semibold text-indigo-500 group-hover:text-indigo-700 transition-colors",
                                                children: "Learn more →"
                                            })
                                        ]
                                    })
                                }, link.href);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                items: faqItems
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactUsHome, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (technologyConsulting);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(8093); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);